import config from '~/config';

export const formatHumanDate = (date: Date, locale: string[] = config.locale) =>
	Intl.DateTimeFormat(locale, {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
	})
		.format(date)
		.replace(/ /g, '\xA0');
